import { NAVIGATION_OPTIONS } from './constants';

export const getActiveNavigationName = (pathname: string): string => {
  const navigationObj = NAVIGATION_OPTIONS.find(
    option => option.path === pathname,
  );
  let name: string = '';
  if (navigationObj) {
    ({ name } = navigationObj);
  } else {
    [{ name }] = NAVIGATION_OPTIONS;
  }
  return name;
};

export const getNavigationPath = (name: string): string => {
  const navigationObj = NAVIGATION_OPTIONS.find(option => option.name === name);
  let path: string = '';
  if (navigationObj) {
    ({ path } = navigationObj);
  } else {
    [{ path }] = NAVIGATION_OPTIONS;
  }
  return path;
};
